import { HttpStatusCode } from "../config/Enum/HttpStatusCode";
import { AlertType } from "../contexts/alert.context";

export class ResponseError implements AlertType {
    statusCode?: HttpStatusCode;
    message?: string;
    status?: "success" | "warning" | "info" | "error";
}
